import axios from "axios";
import { USERURL, USERCONFIGURL } from "./../helpers/constants";
import { 
  login, 
  logout, 
  //signup, 
  //forgotPW 
} from "../api/login";

const RECEIVE_USER = "RECEIVE_USER";
const RECEIVE_USER_START = "RECEIVE_USER_START";
const RECEIVE_USER_FINISHED = "RECEIVE_USER_FINISHED";
const CLEAR_USER = "CLEAR_USER";
const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
//const SET_SIGNUP_ERROR = "SET_SIGNUP_ERROR";
//const SET_FORGOT_ERROR = "SET_FORGOT_ERROR";
const RECEIVE_PERSISTET_WIDGET_CONFIG = "RECEIVE_PERSISTET_WIDGET_CONFIG";
const RECEIVE_PERSISTET_UI_CONFIG = "RECEIVE_PERSISTET_UI_CONFIG";
const LOGOUT_USER = "LOGOUT_USER";

/* API CALL THUNKS */

const fetchUser = cb => {
  return function(dispatch) {
    console.log("fetchUser THUNK CALLED");
    dispatch(receiveUserStart());
    axios
      .get(USERURL)
      .then(function(response) {
        // handle success
        dispatch(receiveUser(response.data));
        if (response.data.config) {
          if (response.data.config.widgetConfig) {
            dispatch(
              receivePersistetWidgetConfig(response.data.config.widgetConfig)
            );
          }
          if (response.data.config.uiConfig) {
            dispatch(receivePersistetUIConfig(response.data.config.uiConfig));
          }
        }

        cb && cb();
      })
      .catch(function(error) {
        // handle error
        console.log("Fetch user error:", error);
        dispatch(receiveUserFinished());
      });
  };
};

const receiveUserStart = () => {
  return {
    type: RECEIVE_USER_START
  };
};
const receiveUserFinished = () => {
  return {
    type: RECEIVE_USER_FINISHED
  };
};

const receiveUser = user => {
  return {
    type: RECEIVE_USER,
    user
  };
};

const clearUser = () => {
  return {
    type: CLEAR_USER
  };
};

const setLoginError = (err = "Something went wrong :(") => {
  return {
    type: SET_LOGIN_ERROR,
    msg: err
  };
};

// const setSignupError = (err = "Something went wrong :(") => {
//   return {
//     type: SET_SIGNUP_ERROR,
//     msg: err
//   };
// };

// const setForgotError = (err = "Something went wrong :(") => {
//   return {
//     type: SET_FORGOT_ERROR,
//     msg: err
//   };
// };

const loginUser = (uname, pw) => {
  return function(dispatch) {
    login(uname, pw)
      .then(res => {
        console.log("LOGIN SUC");
        //dispatch(fetchUser());
      })
      .catch(err => {
        console.log("LOGIN ERR", err);
        let errMsg = undefined;
        try {
          errMsg = err.response.data.error;
        } catch (error) {}
        dispatch(setLoginError(errMsg));
      });
  };
};

const logoutUser = target => {
console.log("post logout. target:", target);
  
return function(dispatch) {
    logout()
      .then(() => {
        console.log("logged out");
        dispatch({
          type: LOGOUT_USER
        });
        console.log("post logout.. target:", target);
        if (!target) {
          window.location = "/login";
        } else {
          window.location = target;
        }
      })
      .catch(() => {
        console.log("log out error");
        dispatch({
          type: LOGOUT_USER
        });
      });
  };
};

const receivePersistetWidgetConfig = widgetConfig => {
  return {
    type: RECEIVE_PERSISTET_WIDGET_CONFIG,
    widgetConfig
  };
};

const persistWidgetConfig = () => {
  return (dispatch, getState) => {
    let widgetConfig = getState().widgetConfig;
    //widgetConfig = JSON.stringify(widgetConfig);

    const payload = { widgetConfig };
    axios
      .post(USERCONFIGURL, payload)
      .then(function(response) {
        console.log("persistWidgetConfig REQ SUCESS", response);
      })
      .catch(function(error) {
        console.log("persistWidgetConfig REQ ERROR", error);
      });
  };
};

const receivePersistetUIConfig = uiConfig => {
  return {
    type: RECEIVE_PERSISTET_UI_CONFIG,
    uiConfig
  };
};

// Persist parts of the UI store
const persistUIConfig = () => {
  return (dispatch, getState) => {
    let uiConfig = getState().uiConfig;

    const payload = { uiConfig };
    axios
      .post(USERCONFIGURL, payload)
      .then(function(response) {
        console.log("persistUIConfig REQ SUCESS", response);
      })
      .catch(function(error) {
        console.log("persistUIConfig REQ ERROR", error);
      });
  };
};

/* EXPORTS */
export const actionsTypes = {
  RECEIVE_USER,
  RECEIVE_USER_START,
  RECEIVE_USER_FINISHED,
  CLEAR_USER,
  SET_LOGIN_ERROR,
  RECEIVE_PERSISTET_WIDGET_CONFIG,
  RECEIVE_PERSISTET_UI_CONFIG
};
export const actionCreators = {
  receiveUser,
  fetchUser,
  clearUser,
  loginUser,
  logoutUser,
  persistWidgetConfig,
  persistUIConfig
};
